import React from 'react';
import { Select } from 'antd';
import { omit } from 'lodash';
import RemoteSelect from './RemoteSelect';
import SelectOptionLabel from './SelectOptionLabel';

const RemoteSelectLedgerAccount = (props) => {
  return (
    <RemoteSelect
      {...props}
      resource="ledger-accounts"
      normalizeFromSelectLabel={(item) =>
        `${item.code} - ${item.description} (${item.classification})`
      }
      optionRender={(c) => {
        return (
          <Select.Option key={c.item.id} value={c.item.id}>
            <SelectOptionLabel {...c.item}>
              <div>
                <div>
                  <span>
                    <strong>{`${c.item.code} - `}</strong>
                  </span>
                  <span>{c.item.description}</span>
                </div>
                <small className="gx-text-grey">{c.item.classification}</small>
              </div>
            </SelectOptionLabel>
          </Select.Option>
        );
      }}
    />
  );
};

export const RemoteSelectLedgerAccountUtils = {
  normalizeToSelect: (item) => {
    if (!item) {
      return null;
    }

    return {
      key: item.id,
      label: `${item.code} - ${item.description} (${item.classification})`,
      item
    };
  },
  normalizeFromSelect: (value) => {
    if (!value) {
      return null;
    }

    if (value?.item) {
      return value.item;
    }

    return omit(value.label?.props, ['children']);
  }
};

export default RemoteSelectLedgerAccount;
